export default __webpack_public_path__ + "e11350304424986c06d80cc8bd6a0598.svg";